import { config } from '../utils/constants/api.constants';

const { baseUrl, userPreferences, count } = config.api.dsaLms;

export default (api) => {
  const getUserPreferences = (params) => {
    const url = `${baseUrl}${userPreferences}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, {
          params,
          parse: true,
          apiKey: 'parseDndData',
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getUserPreferencesCount = (params) => {
    const url = `${baseUrl}${userPreferences}${count}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, {
          params,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const saveUserPreferences = (rawData) => {
    const url = `${baseUrl}${userPreferences}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getUserPreferences,
    getUserPreferencesCount,
    saveUserPreferences,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
